import React from 'react';
import { useLocation } from 'react-router-dom';

const Header: React.FC = () => {

  const location = useLocation();

  const isProductDetail = location.pathname.startsWith('/productos/');

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <h1 className="sitename">Qori Solutions</h1>
        </a>
        <nav id="navmenu" className="navmenu">
          <ul>
            {isProductDetail ? (
              <>
                <li>
                  <a href="/">Inicio</a>
                </li>
                <li>
                  <a href="#contact">Contacto</a>
                </li>
              </>
            ) : (
              <>
                <li>
                  <a href="#hero" className="active">Inicio</a>
                </li>
                <li>
                  <a href="#about">Acerca de</a>
                </li>
                <li>
                  <a href="#services">Nuestros Servicios</a>
                </li>
                <li>
                  <a href="#products">Productos</a>
                </li>
                <li>
                  <a href="#news">Anuncios</a>
                </li>
                <li>
                  <a href="#contact">Contacto</a>
                </li>
              </>
            )}
          </ul>
          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>
      </div>
    </header>
  );
};

export default Header;
